
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.826 4.01L8.853.169A.6.6 0 008.435 0H.591A.58.58 0 000 .571V15.43A.58.58 0 00.59 16h11.82a.58.58 0 00.59-.571V4.416a.565.565 0 00-.174-.405zm-1.189.669H8.162V1.318l3.475 3.36zm.034 10.035H1.33V1.286h5.576v3.857c0 .199.082.39.227.53a.79.79 0 00.549.22h3.989v8.821z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.982 10.224a.437.437 0 10-.636.6l.989 1.046c.08.083.187.13.299.13.112 0 .22-.047.299-.13L9.468 8.13a.435.435 0 00-.632-.597l-3.2 3.385-.654-.695z","fill":"currentColor","stroke":"currentColor","stroke-width":".5"}})])
          )
        }
      }
    